export default "__VITE_ASSET__Do$RLrmT__"